import { IRelNotaUnidadeTotalCleanDTO, IRelNotaUnidadeTotalDTO, IRelNotaUnidadeTotalFullDTO } from "../models/happy-code-api.model";
import { baseFindList } from "./base/base-find-list.service";

export const useRelNotaUnidadeTotalService = () => {
  const resourceURL = 'rel-nota-unidade-total';

  return {
    ...baseFindList<IRelNotaUnidadeTotalCleanDTO, IRelNotaUnidadeTotalDTO, IRelNotaUnidadeTotalFullDTO>(resourceURL),
  };
}